import { withChartLayout } from 'components/common';
import RespiratoryInterventions from 'components/features/chart/system-nursing-interventions/respiratory-interventions/RespiratoryInterventions';

const RespiratoryInterventionsPage = withChartLayout('Respiratory Interventions')(RespiratoryInterventions);
export default RespiratoryInterventionsPage;
